export enum InputType {
	Text = 0,
	Number = 1,
	Currency = 2,
	Textarea = 3,
	Editor = 4,
	Switch = 5,
	Approval = 6,
	Checkbox = 7,
	Date = 8,
	Select = 9,
	DateTime = 10,
	Percentage = 12,
	Radio = 13
}
